const BLACK = [
    0,
    0,
    0
];
/**
 * Please remove # before passing the hex
 */ export const getRGBFromHex = (hex)=>{
    if (hex.length !== 6) {
        return BLACK;
    }
    const aRgbHex = hex.match(/.{1,2}/g);
    if (aRgbHex) {
        const aRgb = [
            parseInt(aRgbHex[0], 16),
            parseInt(aRgbHex[1], 16),
            parseInt(aRgbHex[2], 16)
        ];
        return aRgb;
    }
    return BLACK;
};
